export const FEATURED_CARD = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.FeaturedCardWidgetElement';
